import {useQuery} from "@tanstack/react-query";
import {Token, UsersApi} from "@devour/client";
import getConfig from "@/utils/getConfig";

/**
 * Response shape for getUsersLeaderboardNickname endpoint
 */
export interface LeaderboardNicknameResponse {
    nickname: string;
}

async function fetchUserLeaderboardNickname(fullToken: Token): Promise<LeaderboardNicknameResponse> {
    return await new UsersApi(getConfig(fullToken)).getUsersLeaderboardNickname() as LeaderboardNicknameResponse;
}

function useUserLeaderboardNicknameQuery(fullToken: Token) {
    return {
        queryKey: [
            "user-leaderboard-nickname",
            fullToken.id,
        ],
        queryFn: () => fullToken ? fetchUserLeaderboardNickname(fullToken) : null,
        staleTime: 24 * 60 * 60000,
        enabled: !!fullToken,
    } as const;
}

export function useGetUserLeaderboardNickname(fullToken: Token) {
    return useQuery(useUserLeaderboardNicknameQuery(fullToken));
}